import { ParamsStore } from '../stores/paramsStore';

export const useSummaryParams = (paramsStore: ParamsStore) => {
  const [adults, childs] = paramsStore.countGuests(paramsStore.guestRooms);

  const params = {
    adults,
    childs,
    from: paramsStore.from,
    to: paramsStore.to,
    roomName: paramsStore.room?.name,
    roomsCount: paramsStore.roomsCount,
    rateName: paramsStore.rate?.name,
    totalPrice: paramsStore.totalPrice,
  };

  return params;
};
